import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  onClick?: () => void;
  className?: string;
  fullWidth?: boolean;
  price?: string;
  originalPrice?: string;
  discountLabel?: string;
}
export function CTAButton({
  text = 'Send Me the 7‑Day Reset →',
  onClick,
  className = '',
  fullWidth = false,
  price,
  originalPrice,
  discountLabel
}: CTAButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      const el = document.getElementById('pricing-cta') || document.getElementById('pricing');
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  };
  return <div className="relative inline-flex flex-col items-center" data-id="element-58">
      {/* Outer ambient glow — always visible */}
      <div className="absolute -inset-4 rounded-3xl pointer-events-none" style={{
      background: 'radial-gradient(ellipse at center, rgba(154,184,135,0.30) 0%, rgba(154,184,135,0.08) 60%, transparent 100%)',
      filter: 'blur(16px)'
    }} data-id="element-59" />

      <motion.button onClick={handleClick} className={`
          relative overflow-hidden
          text-white font-semibold text-lg md:text-xl py-4 px-8 rounded-2xl
          flex items-center justify-center gap-3
          transition-all duration-300
          ${fullWidth ? 'w-full' : 'w-full md:w-auto'}
          ${className}
        `} style={{
      background: 'linear-gradient(160deg, #a8c496 0%, #8fa87a 30%, #7B8E6B 60%, #6d7f5e 100%)',
      boxShadow: ['0 0 24px rgba(154,184,135,0.45)', '0 0 60px rgba(154,184,135,0.20)', '0 8px 32px rgba(123,142,107,0.50)', '0 2px 8px rgba(123,142,107,0.25)', 'inset 0 1px 0 rgba(255,255,255,0.30)', 'inset 0 -1px 2px rgba(0,0,0,0.08)'].join(', ')
    }} whileHover={{
      scale: 1.03,
      boxShadow: ['0 0 36px rgba(154,184,135,0.60)', '0 0 80px rgba(154,184,135,0.30)', '0 12px 44px rgba(123,142,107,0.60)', '0 4px 14px rgba(123,142,107,0.35)', 'inset 0 1px 0 rgba(255,255,255,0.35)', 'inset 0 -1px 2px rgba(0,0,0,0.06)'].join(', ')
    } as any} whileTap={{
      scale: 0.97
    }} data-id="element-60">
        {/* Soft inner light at top */}
        <span className="absolute top-0 left-1/2 -translate-x-1/2 w-3/4 h-px pointer-events-none" style={{
        background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.50), transparent)'
      }} data-id="element-61" />

        {/* Shimmer sweep */}
        <motion.span className="absolute inset-0 rounded-2xl pointer-events-none" style={{
        background: 'linear-gradient(105deg, transparent 35%, rgba(255,255,255,0.22) 48%, rgba(255,255,255,0.08) 52%, transparent 65%)',
        backgroundSize: '250% 100%'
      }} initial={{
        backgroundPosition: '250% 0'
      }} whileHover={{
        backgroundPosition: '-250% 0'
      }} transition={{
        duration: 0.8,
        ease: 'easeInOut'
      }} data-id="element-62" />

        {/* Breathing pulse glow */}
        <motion.span className="absolute inset-0 rounded-2xl pointer-events-none" style={{
        boxShadow: '0 0 20px rgba(154,184,135,0.35)'
      }} animate={{
        opacity: [0.4, 0.8, 0.4]
      }} transition={{
        duration: 3,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-63" />

        {discountLabel && <span className="absolute -top-3 -right-3 bg-terracotta text-white text-xs font-bold px-2.5 py-1 rounded-full shadow-md" data-id="element-64">
            {discountLabel}
          </span>}
        <span className="relative z-10" data-id="element-65">{text}</span>
        <ArrowRight className="relative z-10 w-5 h-5 ml-1" data-id="element-66" />
      </motion.button>
    </div>;
}